import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  CouponModal,
  DeleteCouponModal,
  OrdersResoldCouponsTable
} from "../../components";
import { CouponType } from "../../constants";
import { useCouponsList } from "../../hooks";

import styles from "./OrdersResoldCoupons.module.scss";

const OrdersResoldCoupons = () => {
  const {
    coupons,
    totalItems,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useCouponsList(CouponType.OrdersResoldCoupon);

  const [deletingCouponId, setDeletingCouponId] = useState<string | null>(null);

  const {
    value: isCouponModalOpen,
    setTrue: openCouponModal,
    setFalse: closeCouponModal
  } = useBoolean(false);

  return (
    <>
      <div className={styles.headerLine}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={"Search..."}
        />

        <Button
          title={"New Coupon"}
          icon={<PlusInSquareIcon />}
          onClick={openCouponModal}
        />
      </div>

      <OrdersResoldCouponsTable
        coupons={coupons}
        sorting={sorting}
        setSorting={setSorting}
        isLoading={isLoading}
        onDeleteCoupon={setDeletingCouponId}
      />

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <CouponModal
        couponType={CouponType.OrdersResoldCoupon}
        isOpen={isCouponModalOpen}
        onClose={closeCouponModal}
      />

      {deletingCouponId && (
        <DeleteCouponModal
          id={deletingCouponId}
          isOpen={!!deletingCouponId}
          couponType={CouponType.OrdersResoldCoupon}
          onClose={() => setDeletingCouponId(null)}
        />
      )}
    </>
  );
};

export default OrdersResoldCoupons;
